import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Footer: React.FC = () => {
  const { t } = useTranslation()

  const textColor = process.env.REACT_APP_ENV === 'rigips' ? 'text-black' : 'text-white'
  const backgroundColor =
    process.env.REACT_APP_ENV === 'rigips' ? 'bg-gray-100' : 'bg-brand-primary'

  const ListItem = ({
    linkTo,
    href,
    children,
  }: {
    linkTo?: string
    href?: string
    children: any
  }) => (
    <li className={`font-400 ${textColor} text-12 tracking-0.32 ml-30 first-child:ml-0`}>
      {linkTo && !href && <Link to={linkTo}>{children}</Link>}
      {href && !linkTo && (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      )}
    </li>
  )

  const Info = ({ children }: { children: any }) => (
    <span
      className={`opacity-50 font-400 ${textColor} text-12 tracking-0.32 ml-30 first-child:ml-0`}
    >
      {children}
    </span>
  )

  return (
    <footer className={`h-65 px-48 w-full ${backgroundColor} flex items-center justify-between`}>
      <ul className="flex items-center">
        <ListItem linkTo="/feedback">{t('feedback')}</ListItem>

        <ListItem
          href={
            process.env.REACT_APP_ENV === 'rigips'
              ? 'https://www.rigips.at/impressum'
              : 'https://www.abk.at/impressum/'
          }
        >
          {t('imprint')}
        </ListItem>
        <ListItem
          href={
            process.env.REACT_APP_ENV === 'rigips'
              ? 'https://www.rigips.at/impressum'
              : 'https://www.abk.at/datenschutz/'
          }
        >
          {t('dataProtection')}
        </ListItem>
        {process.env.REACT_APP_ENV !== 'rigips' && (
          <ListItem linkTo="/faq/terms-of-use">{t('termsOfUse')}</ListItem>
        )}
        {process.env.REACT_APP_ENV !== 'rigips' && (
          <ListItem linkTo="/">{t('participating_manufacturers')}</ListItem>
        )}
      </ul>
      <div className="flex items-center">
        <Info>{t('lastUpdate')}: 31.05.2021</Info>
        <Info>
          © {new Date().getFullYear()}{' '}
          {process.env.REACT_APP_ENV === 'rigips' ? 'SG Rigips' : 'ib-data GmbH'}
        </Info>
      </div>
    </footer>
  )
}

export default Footer
